import PrefabsItem from '../PrefabsItem';
import {useGetPrefabStringV2MCQuery} from "../../../core/api/mc-prefab-api"; // Import the generic component

function PrefabsMCItem({ selectedItem, setSelectedItem }) {
    return (
        <PrefabsItem
            selectedItem={selectedItem}
            setSelectedItem={setSelectedItem}
            useQueryHook={useGetPrefabStringV2MCQuery} // Pass the specific query hook
        />
    );
}

export default PrefabsMCItem;